// src/components/AdminNav.jsx
import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./AdminNav.css";

export default function AdminNav({ className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { label: "Dashboard", path: "/admin" },
    { label: "Support", path: "/admin/support" },
    { label: "Orders", path: "/admin/orders" },
    { label: "Inventory", path: "/admin/inventory" },
    { label: "SmartTags", path: "/admin/tags" },
    { label: "X Replies", path: "/admin/x-replies" },
    { label: "X Posts", path: "/admin/x-posts" },
      { label: "Batch Orders", path: "/admin/tag-batches" },
  ];

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <div className={`admin-nav-wrap ${className}`}>
      <ButtonGroup className="admin-nav-group" size="sm">
        {links.map((l) => (
          <Button
            key={l.path}
            className={`admin-nav-btn ${isActive(l.path) ? "is-active" : ""}`}
            variant={isActive(l.path) ? "primary" : "outline-primary"}
            onClick={() => navigate(l.path)}
          >
            {l.label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
}
